import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChevronRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

function ProductTile({ p, i }) {
  return (
    <div className={`flex flex-col overflow-hidden rounded-xl bg-white shadow-lg transition-transform duration-500 ${i === 1 ? "sm:-translate-y-3" : ""}`}>
      <img src={`${API}/api/shop/media/${p.id}?w=300`} alt={p.title} className="aspect-square w-full object-contain p-2" />
      <div className="hidden truncate border-t border-[#f0f1f3] px-2 py-1.5 text-[11px] font-medium text-[#32363a] sm:block">{p.title}</div>
    </div>
  );
}

export function BqHero({ slides, cats, onOpenCat }) {
  const [slide, setSlide] = useState(0);
  const [groups, setGroups] = useState({});
  useEffect(() => {
    api.get("/shop/hero-products?per=3").then((r) => {
      setGroups(Object.fromEntries((r.data.groups || []).map((g) => [g.category, g])));
    }).catch(() => {});
  }, []);
  useEffect(() => { const t = setInterval(() => setSlide((s) => (s + 1) % slides.length), 6000); return () => clearInterval(t); }, [slides.length]);
  const hero = slides[slide] || slides[0];
  const g = groups[hero.cat];
  const cat = (cats || []).find((c) => c.title === hero.cat);
  return (
    <div data-testid="shop-hero" className="relative overflow-hidden rounded-2xl bg-[#161d23] shadow-sm">
      {slides.map((s, i) => s.bg && (
        <img key={s.bg} data-testid={`hero-bg-${i}`} src={s.bg} alt="" aria-hidden="true"
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${i === slide ? "opacity-100" : "opacity-0"}`} />
      ))}
      {hero.bg && <div data-testid="hero-overlay" className="absolute inset-0" style={{ background: "linear-gradient(90deg, color-mix(in srgb, var(--brand) 92%, transparent) 0%, color-mix(in srgb, var(--brand) 70%, transparent) 45%, transparent 85%)" }} />}
      {!hero.bg && <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[var(--brand)] opacity-20 blur-3xl" />}
      <div className="relative grid min-h-[18rem] items-center gap-6 px-6 py-8 sm:px-10 lg:grid-cols-[1.1fr_1fr]">
        <div key={slide} className="flex flex-col gap-3 animate-in fade-in slide-in-from-left-4 duration-500">
          <span data-testid="hero-eyebrow" className={`text-[11px] font-semibold uppercase tracking-[0.2em] ${hero.bg ? "text-white/85" : "text-[var(--brand)]"}`}>{hero.eyebrow}</span>
          <h1 data-testid="hero-title" className="text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">{hero.title}</h1>
          <p className="max-w-lg text-sm text-white/90">{hero.sub}</p>
          <div><button data-testid="hero-cta" onClick={() => cat && onOpenCat(cat, [cat])} className={`mt-1 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold shadow-lg transition ${hero.bg ? "bg-white text-[var(--brand)] hover:bg-white/90" : "bg-[var(--brand)] text-white hover:bg-[var(--brand-hover)]"}`}>{hero.cta} <ChevronRight size={16} /></button></div>
        </div>
        <div key={`p${slide}`} data-testid="hero-products" className="grid grid-cols-3 gap-2 pb-4 animate-in fade-in zoom-in-95 duration-500 sm:gap-3 sm:pb-0">
          {(g?.products || []).map((p, i) => <ProductTile key={p.id} p={p} i={i} />)}
        </div>
      </div>
      <div className="absolute bottom-4 left-6 flex gap-1.5 sm:left-10">
        {slides.map((_, i) => (
          <button key={i} data-testid={`hero-dot-${i}`} onClick={() => setSlide(i)} className={`h-1.5 rounded-full transition-all ${i === slide ? `w-6 ${hero.bg ? "bg-white" : "bg-[var(--brand)]"}` : "w-2.5 bg-white/40 hover:bg-white/70"}`} aria-label={`Slide ${i + 1}`} />
        ))}
      </div>
    </div>
  );
}
